import { useState, useEffect, useContext } from "react";
import { createPortal } from "react-dom";
import React from "react";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import Select from "react-select";
import sendRequest from "hooks/useAxios";
import sendRequest2 from "hooks/useAxios2";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { AiOutlinePlus } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Orders from "./Orders";
import WithAuthentication from "Authentication/AuthenticationContext.ts";

export default function AddTransactionModal({
  setUpdater,
  selectedItem,
  type,
}) {
  // const [valueDatePayan, setValueDatePayan] = useState("");
  const auth = useContext(WithAuthentication);
  const [selected, setSelected] = useState({});
  const [transactData, setTransactData] = useState({
    // transaction_type: "1",
    muid: "",
    paid_tm: "",
    amount: "",
  });
  const navigate = useNavigate();

  // افزودن تراکنش جدید
  const addTransact = () => {
    sendRequest2("add_transactions", {
      order_id: selected.id,
      amount: transactData.amount,
      paid_tm: transactData.paid_tm.unix,
      muid: auth.userInfo.id,
      transaction_type: 0,
      type: 2,
      deposit: 1,
      sender: 4,
      // sender: selected.rescipient_fname + " " + selected.rescipient_lname
      // sender: transactData.user
      // sender: userOrder.uid
    }).then(({ data }) => {
      if (data.status == 1) {
        Swal.fire("تراکنش با موفقیت ذخیره شد.");

        setUpdater((prev) => {
          return !prev;
        });
        setTransactData({
          // transaction_type: "1",
          muid: "",
          paid_tm: "",
          amount: 0,
        });
        setUserOrder([]);

        document.querySelector("#transactionModal .btn-close").click();
      }
    });
  };

  const [users, setUsers] = useState([]);
  // نمایش کاربران و شماره موبایلشان در مدال
  useEffect(() => {
    sendRequest("Find_users").then(({ data }) => {
      setUsers(data);
    });
  }, []);
  useEffect(() => {
    setTransactData((prev) => {
      return {
        ...prev,
        amount: 0,
      };
    });
  }, [selected]);
  const translateToReactSelect1 = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.txt = arrayValue[index].label;
        obj.id = arrayValue[index].value;
        after.push(obj);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label =
          arrayValue[index].fname +
          " " +
          arrayValue[index].lname +
          " - " +
          arrayValue[index].mobile;
        obj.value = arrayValue[index].id;
        after.push(obj);
      }
    }

    return after;
  };
  const translateUserToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        if (arrayValue[index].id) {
          // obj.id = arrayValue[index].id;
        } else {
          // obj.title = arrayValue[index].label;
          // obj.id = arrayValue[index].value;
        }

        after.push(obj.id);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = `شماره سفارش: ${
          arrayValue[index].order_code
        } - تاریخ :${showTime(arrayValue[index].mtm)}- مبلغ کل : ${
          arrayValue[index].total_amount
        } - مبلغ مانده: ${
          arrayValue[index].total_amount - arrayValue[index].paid_amount
        } `;
        obj.data = arrayValue[index];
        obj.value = arrayValue[index].id;
        // obj.mobile = arrayValue[index].mobile;

        after.push(obj);
      }
    }

    return after;
  };

  const apiUsers = translateToReactSelect1(users, false);
  // نمایش مجموعه ای از سفارشات با radiobutton
  const [userOrder, setUserOrder] = useState([
    // {
    // numberOfOrder:"1234",
    // numberOfItems:"10",
    // dateOfOrder:"1401/02/12",
    // totalPrice:"100000",
    // paidPrice:"80000"
    // }
  ]);

  const [transactError, setTransactError] = useState({
    user: false,
    date: false,
    price: false,
  });

  const checkPriceNull = () => {
    if (transactData.amount == "") {
      setTransactError((prev) => {
        return { ...prev, price: true };
      });
    } else {
      setTransactError((prev) => {
        return { ...prev, price: false };
      });
    }
  };

  const checkDateNull = () => {
    if (transactData.paid_tm == "") {
      setTransactError((prev) => {
        return { ...prev, date: true };
      });
    } else {
      setTransactError((prev) => {
        return { ...prev, date: false };
      });
    }
  };

  const checkUserNull = () => {
    if (transactData.muid == "") {
      setTransactError((prev) => {
        return { ...prev, user: true };
      });
    } else {
      setTransactError((prev) => {
        return { ...prev, user: false };
      });
    }
  };
  function showTime(x) {
    x = x * 1000;
    const date = new DateObject({ date: x, calendar: persian });
    return date.format();
  }
  const findOrders = (x) => {
    sendRequest("Find_orders", { conditions: `uid/=/${x}` }).then(
      ({ data }) => {
        const lists = translateUserToReactSelect(data, false);
        console.log("list", lists);
        console.log("data", data);
        setUserOrder((prev) => {
          return [...lists];
        });
        // setUserOrder(data);
      }
    );
  };
  // نمایش سفارشهای کاربر بعد از انتخاب کاربر
  // const findOrders = x => {
  //   sendRequest("Find_orders", { conditions: `uid/=/${x}` }).then(
  //     ({ data }) => {
  //       setUserOrder(data);
  //     }
  //   );
  // };
  const addTransaction = (
    <div
      className="modal fade mx-auto"
      id="transactionModal"
      tabIndex={-1}
      aria-labelledby="transactionModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <div>
              <h5>اضافه کردن تراکنش</h5>

              <div className="d-flex align-items-center mt-4 ">
                <div className="col-2 ">
                  <label for="user">کاربر </label>
                </div>
                {selectedItem ? (
                  <p>
                    {selectedItem.user_muid.fname +
                      " " +
                      selectedItem.user_muid.lname}{" "}
                  </p>
                ) : (
                  <div className="col-10 ">
                    <Select
                      className="fs-10"
                      options={apiUsers}
                      id="user"
                      value={transactData.muid}
                      onChange={(e) => {
                        setTransactData((prev) => {
                          return { ...prev, muid: e };
                        });

                        findOrders(e.value);
                      }}
                    />
                    <p
                      className={`text-danger fs-12 ${
                        transactError.user == true ? "d-block" : "d-none"
                      }`}
                    >
                      این فیلد نمی تواند خالی باشد
                    </p>
                  </div>
                )}
              </div>

              <div className="row mt-3">
                <div className="col-6">
                  <div className="d-flex align-items-center">
                    <div className="col-4">
                      <label for="date">تاریخ </label>
                    </div>

                    <div className="col-8 boxDate" id="date">
                      {/* <input type="text" className="form-control"> */}
                      <DatePicker
                        className="rmdp-prime"
                        showOtherDays
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        value={transactData.paid_tm}
                        // value={valueDatePayan}
                        onChange={(date) => {
                          // setValueDatePayan(date);
                          setTransactData((prev) => {
                            return { ...prev, paid_tm: date };
                          });
                          checkDateNull();
                        }}
                      />
                      <p
                        className={`text-danger fs-12 ${
                          transactError.date == true ? "d-block" : "d-none"
                        }`}
                      >
                        این فیلد نمی تواند خالی باشد
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-6 ">
                  <div className="d-flex align-items-center">
                    <div className="col-3">
                      <label for="price">مبلغ</label>
                    </div>
                    {type == "order" ? (
                      <div className="col-9">
                        <input
                          className="form-control"
                          id="price"
                          value={addCommas(+transactData.amount)}
                          onKeyUp={checkPriceNull}
                          onChange={(e) => {
                            if (
                              removeCommas(e.target.value) <=
                              selectedItem.total_amount -
                                selectedItem.total_discount
                            )
                              setTransactData((prev) => {
                                return {
                                  ...prev,
                                  amount: removeCommas(e.target.value),
                                };
                              });
                            // else {
                            //   setErrorMore(true);
                            // }
                          }}
                        />
                      </div>
                    ) : (
                      <div className="col-9">
                        <input
                          className="form-control"
                          id="price"
                          value={addCommas(+transactData.amount)}
                          onKeyUp={checkPriceNull}
                          onChange={(e) => {
                            if (
                              removeCommas(e.target.value) <=
                              selected.total_amount -
                                selected.total_discount -
                                selected.paid_amount
                            )
                              setTransactData((prev) => {
                                return {
                                  ...prev,
                                  amount: removeCommas(e.target.value),
                                };
                              });
                            // else {
                            //   setErrorMore(true);
                            // }
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <p
                    className={`text-danger ms-5 fs-12 ${
                      transactError.price == true ? "d-block" : "d-none"
                    }`}
                  >
                    این فیلد نمی تواند خالی باشد
                  </p>
                  {/* <p
                    className={`text-danger ms-5 fs-12 ${
                      priceMore == true ? "d-block" : "d-none"
                    }`}
                  >
                    مبلغ وارد شده نباید از مبلغ وارد شده بیشتر باشد
                  </p> */}
                </div>
              </div>
            </div>
            {/* radiobutton */}
            <div>
              {/* {userOrder.map((value, index) => { */}
              {/* return ( */}
              <Orders
                // setSelected={setSelected}
                // indexId={index}
                // numberOfOrder={value.order_code}
                // numberOfItems={value.items_count}
                // dateOfOrder={value.mtm}
                // totalPrice={value.total_amount}
                // paidPrice={value.paid_amount}
                // discountPrice={value.total_discount}
                // value={value}
                userOrder={userOrder}
                setSelected={setSelected}
              ></Orders>
              {/* ); */}
              {/* })} */}
            </div>
            {/* end radiobutton */}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              بستن
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={() => {
                checkPriceNull();
                checkUserNull();
                checkDateNull();
                if (
                  transactError.user == false &&
                  transactError.date == false &&
                  transactError.price == false
                ) {
                  addTransact();
                }

                // checkMore();
              }}
            >
              ذخیره
            </button>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <>
      <div className=" mx-5 mt-4">
        <button
          className="btn text-white px-4 py-3"
          data-bs-toggle="modal"
          data-bs-target="#transactionModal"
          style={{ backgroundColor: "#203b8c" }}
        >
          <AiOutlinePlus className="text-white fw-bolder me-2"></AiOutlinePlus>
          اضافه کردن تراکنش
        </button>
        {createPortal(addTransaction, document.getElementById("modals"))}
      </div>
    </>
  );
}
